var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from 'prop-types';
import Viewport from 'cf-component-viewport';
import Select from 'cf-component-select';

var find = function find(list, condition) {
  var foundElement = undefined;
  list.forEach(function (element) {
    if (condition(element)) {
      foundElement = element;
    }
  });
  return foundElement;
};

var Tabs = function (_React$Component) {
  _inherits(Tabs, _React$Component);

  function Tabs() {
    _classCallCheck(this, Tabs);

    return _possibleConstructorReturn(this, (Tabs.__proto__ || Object.getPrototypeOf(Tabs)).apply(this, arguments));
  }

  _createClass(Tabs, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        active: this.props.active
      };
    }
  }, {
    key: 'handleChange',
    value: function handleChange(id) {
      if (id !== this.props.active) {
        this.props.onChange(id);
      }
    }
  }, {
    key: 'handleKeyDown',
    value: function handleKeyDown(id, event) {
      if (event.which === 13) {
        this.handleChange(id);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return React.createElement(
        'section',
        { className: 'cf-tabs' },
        React.createElement(
          Viewport,
          { size: 'mobile' },
          React.createElement(Select, {
            onChange: this.handleChange.bind(this),
            value: this.props.active,
            options: this.props.tabs.map(function (tab) {
              return {
                value: tab.id,
                label: tab.label
              };
            })
          })
        ),
        React.createElement(
          Viewport,
          { not: true, size: 'mobile' },
          React.createElement(
            'ul',
            { className: 'cf-tabs__group', role: 'tablist' },
            this.props.tabs.map(function (tab) {
              var selected = tab.id === _this2.props.active;

              var className = 'cf-tabs__item';
              if (selected) {
                className += ' cf-tabs__item--active';
              }

              return React.createElement(
                'li',
                {
                  key: tab.id,
                  role: 'tab',
                  tabIndex: 0,
                  'aria-controls': tab.id,
                  'aria-selected': selected,
                  className: className,
                  onKeyDown: _this2.handleKeyDown.bind(_this2, tab.id),
                  onClick: _this2.handleChange.bind(_this2, tab.id)
                },
                tab.label
              );
            })
          )
        ),
        find(this.props.children, function (child) {
          return child.props.id === _this2.props.active;
        })
      );
    }
  }]);

  return Tabs;
}(React.Component);

Tabs.propTypes = {
  onChange: PropTypes.func.isRequired,
  active: PropTypes.string.isRequired,
  tabs: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
  })).isRequired,
  children: PropTypes.arrayOf(PropTypes.element).isRequired
};

Tabs.childContextTypes = {
  active: PropTypes.string.isRequired
};

export default Tabs;


//////////////////
// WEBPACK FOOTER
// ./node_modules/cf-component-tabs/es/Tabs.js
// module id = 539
// module chunks = 0